import type { LedgerItem, UsageDay } from '@lyra/shared';
import { formatNumberRo } from '@/lib/format';

const KIND_LABELS: Record<string, string> = {
  grant: 'Alimentare',
  burn: 'Consum instanță',
  adjustment: 'Ajustare',
  expiry: 'Expirare',
};
export function ledgerKindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? kind;
}

/** Running "sold curent" per row: the items are newest-first; the newest row's
 *  running balance IS the current balance, and each older row is the balance
 *  BEFORE the newer row's delta was applied. Correct when the page starts at
 *  the newest entry (page 1); later pages are anchored to the page, which is
 *  acceptable for the pilot. */
export function computeRunningBalances(items: LedgerItem[], currentBalanceEur: number): number[] {
  const out: number[] = [];
  let running = currentBalanceEur;
  for (const item of items) {
    out.push(Math.round(running * 100) / 100);
    running = Math.round((running - item.deltaEur) * 100) / 100;
  }
  return out;
}

export interface UsageBar { date: string; burnEur: number; heightPct: number; isPeak: boolean; }
export function buildUsageBars(days: UsageDay[]): UsageBar[] {
  const max = days.reduce((m, d) => Math.max(m, d.burnEur), 0);
  return days.map((d) => ({
    date: d.date,
    burnEur: d.burnEur,
    heightPct: max > 0 ? Math.round((d.burnEur / max) * 100) : 0,
    isPeak: max > 0 && d.burnEur === max,
  }));
}

const STOP_REASONS: Record<string, string> = {
  user: 'Oprită manual',
  idle: 'Oprită automat (inactivitate)',
  admin: 'Oprită de administrator',
  provision_failed: 'Pornire eșuată',
};
export function stopReasonLabel(r: string | null): string {
  return r ? (STOP_REASONS[r] ?? 'Stare necunoscută') : 'Activă';
}

export function formatBilledHours(h: number): string {
  return `${formatNumberRo(Math.round(h * 10) / 10)} h`;
}
